import {
  FILE_VIDEO,
  FILE_WORD,
  FILE_TEXT,
  FILE_ZIP,
  FILE_EXCEL,
  FILE_PPT,
  FILE_PDF,
  FILE_CODE,
  FILE_DEFAULT,
} from './icons';

export enum FileType {
  AUDIO,
  VIDEO,
  WORD,
  TEXT,
  ZIP,
  EXCEL,
  PPT,
  PDF,
  CODE,
  IMAGE,
  DEFAULT,
}

export const fileTypeMap: { [key: string]: FileType } = {
  m4v: FileType.VIDEO,
  avi: FileType.VIDEO,
  mpg: FileType.VIDEO,
  mp4: FileType.VIDEO,
  flv: FileType.VIDEO,
  mov: FileType.VIDEO,
  wmv: FileType.VIDEO,
  doc: FileType.WORD,
  docx: FileType.WORD,
  docm: FileType.WORD,
  dotm: FileType.WORD,
  dotx: FileType.WORD,
  txt: FileType.TEXT,
  rar: FileType.ZIP,
  zip: FileType.ZIP,
  pkg: FileType.ZIP,
  xml: FileType.EXCEL,
  csv: FileType.EXCEL,
  xlsx: FileType.EXCEL,
  xls: FileType.EXCEL,
  xlsm: FileType.EXCEL,
  xlsb: FileType.EXCEL,
  ppt: FileType.PPT,
  pptx: FileType.PPT,
  pps: FileType.PPT,
  ppsx: FileType.PPT,
  pptm: FileType.PPT,
  potm: FileType.PPT,
  ppam: FileType.PPT,
  potx: FileType.PPT,
  ppsm: FileType.PPT,
  pdf: FileType.PDF,
  css: FileType.CODE,
  js: FileType.CODE,
  jsx: FileType.CODE,
  md: FileType.CODE,
  sql: FileType.CODE,
  bmp: FileType.IMAGE,
  gif: FileType.IMAGE,
  ico: FileType.IMAGE,
  jpeg: FileType.IMAGE,
  jpg: FileType.IMAGE,
  png: FileType.IMAGE,
  svg: FileType.IMAGE,
  tif: FileType.IMAGE,
  tiff: FileType.IMAGE,
};

export const fileIconMap: { [key in FileType]: any } = {
  [FileType.AUDIO]: FILE_DEFAULT,
  [FileType.VIDEO]: FILE_VIDEO,
  [FileType.WORD]: FILE_WORD,
  [FileType.TEXT]: FILE_TEXT,
  [FileType.ZIP]: FILE_ZIP,
  [FileType.EXCEL]: FILE_EXCEL,
  [FileType.PPT]: FILE_PPT,
  [FileType.PDF]: FILE_PDF,
  [FileType.CODE]: FILE_CODE,
  [FileType.IMAGE]: FILE_DEFAULT,
  [FileType.DEFAULT]: FILE_DEFAULT,
};

const mimeFileTypeMap: { [key: string]: FileType } = {
  'application/x-troff-msvideo': FileType.VIDEO,
  'video/avi': FileType.VIDEO,
  'video/msvideo': FileType.VIDEO,
  'video/x-msvideo': FileType.VIDEO,
  'video/avs-video': FileType.VIDEO,
  'image/bmp': FileType.IMAGE,
  'image/x-windows-bmp': FileType.IMAGE,
  'application/x-pointplus': FileType.CODE,
  'text/css': FileType.CODE,
  'application/msword': FileType.WORD,
  'text/html': FileType.CODE,
  'image/jpeg': FileType.IMAGE,
  'image/pjpeg': FileType.IMAGE,
  'image/x-jps': FileType.IMAGE,
  'application/x-javascript': FileType.CODE,
  'application/javascript': FileType.CODE,
  'application/ecmascript': FileType.CODE,
  'text/javascript': FileType.CODE,
  'application/x-midi': FileType.AUDIO,
  'audio/midi': FileType.AUDIO,
  'audio/x-mid': FileType.AUDIO,
  'audio/x-midi': FileType.AUDIO,
  'music/crescendo': FileType.AUDIO,
  'x-music/x-midi': FileType.AUDIO,
  'video/quicktime': FileType.VIDEO,
  'video/x-sgi-movie': FileType.VIDEO,
  'audio/mpeg': FileType.AUDIO,
  'audio/x-mpeg': FileType.AUDIO,
  'video/mpeg': FileType.VIDEO,
  'video/x-mpeg': FileType.VIDEO,
  'video/x-mpeq2a': FileType.VIDEO,
  'audio/mpeg3': FileType.AUDIO,
  'audio/x-mpeg-3': FileType.AUDIO,
  'application/pdf': FileType.PDF,
  'image/png': FileType.IMAGE,
  'application/mspowerpoint': FileType.PPT,
  'application/vnd.ms-powerpoint': FileType.PPT,
  'model/x-pov': FileType.PPT,
  'application/powerpoint': FileType.PPT,
  'application/x-mspowerpoint': FileType.PPT,
  'application/plain': FileType.TEXT,
  'text/plain': FileType.TEXT,
  'image/tiff': FileType.IMAGE,
  'image/x-tiff': FileType.IMAGE,
  'application/excel': FileType.EXCEL,
  'application/x-excel': FileType.EXCEL,
  'application/x-msexcel': FileType.EXCEL,
  'application/vnd.ms-excel': FileType.EXCEL,
  'application/x-compressed': FileType.ZIP,
  'application/x-zip-compressed': FileType.ZIP,
  'application/zip': FileType.ZIP,
  'multipart/x-zip': FileType.ZIP,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': FileType.WORD,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': FileType.WORD,
  'application/vnd.ms-word.document.macroEnabled.12': FileType.WORD,
  'application/vnd.ms-word.template.macroEnabled.12': FileType.WORD,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': FileType.EXCEL,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': FileType.EXCEL,
  'application/vnd.ms-excel.sheet.macroEnabled.12': FileType.EXCEL,
  'application/vnd.ms-excel.template.macroEnabled.12': FileType.EXCEL,
  'application/vnd.ms-excel.addin.macroEnabled.12': FileType.EXCEL,
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': FileType.EXCEL,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': FileType.PPT,
  'application/vnd.openxmlformats-officedocument.presentationml.template': FileType.PPT,
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': FileType.PPT,
  'application/vnd.ms-powerpoint.addin.macroEnabled.12': FileType.PPT,
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12': FileType.PPT,
  'application/vnd.ms-powerpoint.template.macroEnabled.12': FileType.PPT,
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': FileType.PPT,
};

/** Helpers for getting file type and icon */
export const getExtension = (filename: string) => {
  const parts = filename.split('.');
  return parts[parts.length - 1].toLowerCase();
};

export const getFileTypeByName = (name: string, type: string) => {
  if (type) {
    return (
      (mimeFileTypeMap[type] as FileType) || fileTypeMap[getExtension(name)] || FileType.DEFAULT
    );
  }

  return fileTypeMap[getExtension(name)] || FileType.DEFAULT;
};
